<div class="modal-header bg-light d-flex justify-content-center">
    <h4 class="modal-title strong" >
        {{ 'home.quote.Acceptoffer' | cxTranslate }}
    </h4>
</div>
    <div class="modal-body bg-light text-center">
      <p>{{ 'home.quote.Thisaccept' | cxTranslate }}</p>
      <p class="xs-semibold-font">{{acceptTxt}}</p>
    </div>
  <div class="modal-footer bg-light border-0">
    <div class="w-100">
      <button class="btn btn-block btn-primary btn-lg" type="submit" data-dismiss="modal" (click)="acceptbid()">
        {{ 'home.quote.Iaccept' | cxTranslate }}
      </button>
      <button class="btn btn-block btn-secondary btn-lg" type="submit" data-dismiss="modal" (click)="close()">
        {{ 'home.quote.Close' | cxTranslate }}
      </button>
    </div>
  </div>

 



